/* =====================================================================
   DERBY - Find my size (2026-09-27).
   Lives inside the theme's Size Guide dialog. The dialog renders one of
   the size-chart pages (class .dsz), whose first column reads "S (38)",
   "M (40)" for tops or "30", "32" for bottoms. Those bracket numbers ARE
   the to-fit body measurement (chest for tops, waist for bottoms), so the
   recommendation is a lookup against the brand's own chart, not a
   height/weight guess. Nothing here invents a number the chart does not
   already carry.
   ===================================================================== */
(function () {
  'use strict';
  if (window.__derbyFitFinder) return;
  window.__derbyFitFinder = true;

  function parseRows(table) {
    var rows = [];
    table.querySelectorAll('tbody tr').forEach(function (tr) {
      var first = tr.querySelector('td');
      if (!first) return;
      var label = first.textContent.trim();
      var m = label.match(/\((\d{2})\)/) || label.match(/^(\d{2})$/);
      if (!m) return;
      rows.push({ tr: tr, label: label, fit: parseInt(m[1], 10) });
    });
    return rows;
  }

  function build(dsz) {
    if (dsz.querySelector('.dff')) return;
    var table = dsz.querySelector('table');
    if (!table) return;
    var rows = parseRows(table);
    if (rows.length < 2) return;

    var head = table.querySelector('thead');
    var headTxt = head ? head.textContent.toLowerCase() : '';
    var isBottom = headTxt.indexOf('inseam') !== -1 || headTxt.indexOf('hip') !== -1;
    var measure = isBottom ? 'waist' : 'chest';

    var box = document.createElement('div');
    box.className = 'dff';
    box.innerHTML =
      '<p class="dff__k">Find my size</p>' +
      '<label class="dff__l" for="dff-in">Your ' + measure + ', measured around, in inches</label>' +
      '<div class="dff__row">' +
        '<input class="dff__in" id="dff-in" type="number" inputmode="numeric" min="24" max="60" step="1" placeholder="' + (isBottom ? 'e.g. 34' : 'e.g. 40') + '">' +
        '<button class="dff__btn" type="button">Show my size</button>' +
      '</div>' +
      '<p class="dff__out" aria-live="polite"></p>' +
      '<p class="dff__how">' + (isBottom
        ? 'Tape around your natural waistline, where the waistband sits. Or take a pair you like, measure the waistband end to end and double it.'
        : 'Tape around the fullest part of your chest, under the arms, tape level. Or measure a shirt you like across the chest and double it.') +
      '</p>';
    dsz.insertBefore(box, dsz.firstChild.nextSibling);

    var input = box.querySelector('.dff__in');
    var out = box.querySelector('.dff__out');

    function clear() {
      dsz.querySelectorAll('tr.dff__hit').forEach(function (tr) { tr.classList.remove('dff__hit'); tr.removeAttribute('data-dff-hit'); });
    }

    function run() {
      var v = parseFloat(input.value);
      // Re-read the live table: the theme can re-render the dialog body
      // after a variant change, which would leave the parsed rows detached.
      var liveTable = dsz.querySelector('table');
      if (liveTable) rows = parseRows(liveTable);
      clear();
      if (!v || v < 24 || v > 60) { out.textContent = 'Enter a number between 24 and 60.'; return; }
      var hit = null, i;
      for (i = 0; i < rows.length; i++) {
        if (rows[i].fit >= v) { hit = rows[i]; break; }
      }
      if (!hit) {
        out.innerHTML = 'That is above our largest size on this chart (<b>' + rows[rows.length - 1].label + '</b>). Message us on WhatsApp at +91 73973 77223 and we will check the style for you.';
        return;
      }
      hit.tr.classList.add('dff__hit');
      hit.tr.setAttribute('data-dff-hit', '1');
      var idx = rows.indexOf(hit);
      var exact = hit.fit === v;
      var msg = 'Take <b>' + hit.label + '</b>.';
      if (!exact) msg += ' Your ' + measure + ' sits between sizes; ' + hit.label + ' is the closer, roomier one.';
      if (idx + 1 < rows.length) msg += ' Prefer it looser? ' + rows[idx + 1].label + '.';
      if (idx > 0 && exact) msg += ' Prefer it snug? ' + rows[idx - 1].label + '.';
      out.innerHTML = msg;
      hit.tr.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    box.querySelector('.dff__btn').addEventListener('click', run);
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
  }

  // PDP entry point: a "Find my size" link beside the theme's Size Guide
  // button, so the tool is discoverable before the dialog is open. Clicking
  // opens the same dialog and drops the cursor in the input.
  function placeLink() {
    var sg = Array.prototype.slice.call(document.querySelectorAll('legend button[aria-controls^="modal-"]'))
      .filter(function (b) { return /size guide/i.test(b.textContent) && !b.parentElement.querySelector('.dff-link'); });
    sg.forEach(function (btn) {
      var a = document.createElement('button');
      a.type = 'button';
      a.className = 'dff-link hdt-s-text hdt-font-medium';
      a.textContent = 'Find my size';
      a.addEventListener('click', function () {
        btn.click();
        setTimeout(function () {
          var inp = document.querySelector('dialog[open] .dff__in');
          if (inp) { inp.focus(); }
        }, 350);
      });
      btn.insertAdjacentText('afterend', ' ');
      btn.insertAdjacentElement('afterend', a);
    });
  }

  function scan() {
    document.querySelectorAll('.hdt-dialog-modal .dsz, .hdt-modal__size-chart .dsz').forEach(build);
    placeLink();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  // The dialog is in the DOM at load, but be safe if the picker hydrates late.
  var n = 0, iv = setInterval(function () { scan(); if (++n > 8) clearInterval(iv); }, 500);
})();
